/**
 * Which drill you are doing, and which ones do not exist yet.
 *
 * The list itself, and the reasoning behind showing the dead entries at all, lives in
 * `lib/drills.ts` — this file is only the markup.
 */
import { DRILLS } from "../lib/drills";

export function DrillList({ value, onChange }: {
  value: string; onChange: (id: string) => void;
}) {
  return (
    <ul className="drills" role="group" aria-label="Drill">
      {DRILLS.map((d) => (
        <li key={d.id}>
          <button type="button"
                  className={`drill ${value === d.id ? "drill-on" : ""}`}
                  aria-pressed={value === d.id}
                  disabled={!d.live}
                  title={d.live ? undefined : "Nothing is published for this street"}
                  onClick={() => onChange(d.id)}>
            <span className="drill-name">{d.label}</span>
            <span className="drill-cap">{d.caption}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
